import { ChangeNotifier } from "subtree.js/core";

/**
 * How many customer carts wait on the merchant: the badge in the shell. Marked
 * stale by the carts page after an approve, reject or edit; the shell reloads.
 */
export class PendingCartsRepository extends ChangeNotifier {
  #count = 0;
  #stale = false;

  get count(): number {
    return this.#count;
  }

  get isStale(): boolean {
    return this.#stale;
  }

  setCount(count: number): void {
    const changed = this.#stale || this.#count !== count;
    this.#stale = false;
    this.#count = count;
    if (changed) this.notifyListeners();
  }

  markStale(): void {
    if (this.#stale) return;
    this.#stale = true;
    this.notifyListeners();
  }

  reset(): void {
    this.#count = 0;
    this.#stale = false;
    this.notifyListeners();
  }
}
